<div class="checkbox">
    <mat-checkbox [formControl]="control()">
        {{title()}}
    </mat-checkbox>
</div>
